import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "..";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const getAllContracts = () => {
  return dispatch => {
    dispatch({ type: "GET_ALL_CONTRACTS_LOADING" });
    api
      .contractsGetAll()
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
        dispatch({ type: "GET_ALL_CONTRACTS_LOADING_DONE" });
      })
      .catch(e => {
        jsError(e);
        dispatch({ type: "GET_ALL_CONTRACTS_LOADING_DONE" });
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "GetAllContractsErrorAlertTitle",
          "Virhe kaikkien työsopimusten haussa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_ALL_CONTRACTS_SUCCEEDED",
  payload: { contracts: data },
});

const operationFail = () => ({
  type: "GET_ALL_CONTRACTS_FAIL"
});
